<template>
  <PreGameModal :progress="progress" :progressTotal="progressTotal">
    <template #content>
      <transition mode="out-in" name="fade">
        <div class="content" v-if="step === 0">
          <div class="title">{{ $t("game.preGameModalInstructions.title") }}</div>
          <div class="listWrapper">
            <ul class="list">
              <li v-safe-html="$t('game.preGameModalInstructions.tip1')"></li>
              <li v-safe-html="$t('game.preGameModalInstructions.tip2')"></li>
              <li v-safe-html="$t('game.preGameModalInstructions.tip3')"></li>
            </ul>
          </div>
          <div class="buttons">
            <Button :label="$t('game.preGameModalInstructions.quitButton')" class="btn secondary outline" @click="$emit('back')" />
            <Button :label="$t('game.preGameModalInstructions.continueButton')" class="btn primary" @click="Next" />
          </div>
        </div>
        <div class="content" v-else>
          <div class="header">
            <div class="iconWrapper">
              <i class="icon bi-exclamation" />
            </div>
            <div class="title">{{ $t("game.preGameModalInstructions.epilepsyTitle") }}</div>
            <div class="text">{{ $t("game.preGameModalInstructions.epilepsyText") }}</div>
          </div>
          <div class="buttons">
            <Button :label="$t('game.preGameModalInstructions.quitButton')" class="btn secondary outline" @click="$emit('back')" />
            <Button :label="$t('game.preGameModalInstructions.continueButton')" class="btn primary" @click="Next" />
          </div>
        </div>
      </transition>
    </template>
  </PreGameModal>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.content {
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;
  width: 100%;

  gap: 40px;

  .title {
    font-size: 32px;
    font-weight: 700;
    text-align: center;

    @media screen and (max-width: $small-screen) {
      font-size: 20px;
    }
  }

  .listWrapper {
    align-self: stretch;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;

    padding: 24px;

    border-radius: 6px;
    border: 2px solid #464646;

    @media screen and (max-width: $small-screen) {
      font-size: 14px;
      padding-left: 16px;
    }

    .list {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      align-self: stretch;



      ::v-deep(b) {
        color: #f2cb36;
        font-weight: 700;
      }
    }
  }

  .buttons {
    display: flex;
    gap: 16px;

    .btn {
      border: 2px solid #464646 !important;
    }
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      margin: 8px 0;
      text-align: center;
    }

    .text {
      text-align: center;
      font-size: 18px;

      @media screen and (max-width: $small-screen) {
        font-size: 14px;
      }
    }

    .iconWrapper {
      width: 64px;
      height: 64px;

      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      font-size: 48px;

      background-color: #f2cb36;
      color: black;

      margin-top: 24px;
    }
  }
}
</style>

<script setup lang="ts">
import { ref } from "vue";

import PreGameModal from "./PreGameModal.vue";

const step = ref(0);

defineProps({
  progress: {
    type: Number,
    required: true,
  },
  progressTotal: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["back", "next"]);

function Next() {
  if (step.value === 0) {
    // If we have already seen the epilepsy warning, we can skip it
    if (localStorage.getItem("sawEpilepsyWarning") === "true") {
      emit("next");
    }
    // Else we show the epilepsy warning
    else if (localStorage.getItem("sawEpilepsyWarning") === "false") {
      step.value = 1;
    } else {
      step.value = 1;
      localStorage.setItem("sawEpilepsyWarning", "true");
    }
  }

  // If we are on the epilepsy warning, we can go to the next step
  else if (step.value === 1) {
    emit("next");
  }
}
</script>
